import React from 'react';

const InvestorNotes = () => {
    return (
        <div>
            <h2>Architecture Diagram</h2>
            <iframe width="768" height="432" src="https://miro.com/app/live-embed/uXjVK2rQNnE=/?moveToViewport=382745,108900,26216,17375&embedId=962704426253" frameBorder="0" scrolling="no" allow="fullscreen; clipboard-read; clipboard-write" allowFullScreen></iframe>
            
            <h2>Cybersecurity & Data Protection</h2>
            <iframe width="768" height="432" src="https://miro.com/app/live-embed/uXjVK2rQNnE=/?moveToViewport=382015,126333,27486,18121&embedId=425456762866" frameBorder="0" scrolling="no" allow="fullscreen; clipboard-read; clipboard-write" allowFullScreen></iframe>
            
            <h2>Scalability</h2>
            <iframe width="768" height="432" src="https://miro.com/app/live-embed/uXjVK2rQNnE=/?moveToViewport=382131,144243,27486,18121&embedId=10465105091" frameBorder="0" scrolling="no" allow="fullscreen; clipboard-read; clipboard-write" allowFullScreen></iframe>
            
            <h2>Unique Product Features</h2>
            <iframe width="768" height="432" src="https://miro.com/app/live-embed/uXjVK2rQNnE=/?moveToViewport=382624,162712,26558,18237&embedId=515075959617" frameBorder="0" scrolling="no" allow="fullscreen; clipboard-read; clipboard-write" allowFullScreen></iframe>
            
            <h2>Challenges Overcome</h2>
            <iframe width="768" height="432" src="https://miro.com/app/live-embed/uXjVK2rQNnE=/?moveToViewport=382479,180694,26558,18237&embedId=330893608079" frameBorder="0" scrolling="no" allow="fullscreen; clipboard-read; clipboard-write" allowFullScreen></iframe>
            
            <h2>Product Testing</h2>
            <iframe width="768" height="432" src="https://miro.com/app/live-embed/uXjVK2rQNnE=/?moveToViewport=382160,198914,26558,18237&embedId=39146182313" frameBorder="0" scrolling="no" allow="fullscreen; clipboard-read; clipboard-write" allowFullScreen></iframe>
        </div>
    );
};

export default InvestorNotes;
